import {
  FieldType,
  IFieldTypeParamsFieldsFragment,
  ITableColumnFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import { dataModelerAddDraftFieldData } from '../../../../redux/slices/dataModeler';
import { useAppDispatch } from '../../../../redux/hooks';
import { useCallback } from 'react';
import DerivedColumnEdit from './DerivedColumnEdit';
import {
  NameWithIconWrapper,
  SpacedConfigurationSeparator,
} from '../DataModelerCommonUI';
import useNewDerivedColumnModel from './useNewDerivedColumnModel';
import { DerivedColumnButtonWrapper } from './DerivedColumnEditUI';
import DerivedDefinitionIcon from '../../../../components/DerivedDefinitionIcon';
import { TextButton } from '../../../../components/Button';

interface IProps {
  viewKey: string;
  tableKey: string;
  availableColumnsFromServer: ITableColumnFieldsFragment[];
  collapsed: boolean;
  setCollapsed: (v: boolean) => void;
}

const DerivedColumnEditNew = ({
  viewKey,
  tableKey,
  availableColumnsFromServer,
  collapsed,
  setCollapsed,
}: IProps) => {
  const dispatch = useAppDispatch();

  const addDerivedColumn = useCallback(
    (
      column: string,
      type: FieldType,
      typeParams: IFieldTypeParamsFieldsFragment,
    ) => {
      const tableColumn: ITableColumnFieldsFragment = {
        __typename: 'TableColumn',
        column,
        type,
        description: null,
        typeParams: {
          ...typeParams,
        },
      };
      dispatch(
        dataModelerAddDraftFieldData({
          viewKey,
          tableKey,
          column: tableColumn,
        }),
      );
    },
    [dispatch, tableKey, viewKey],
  );

  const {
    columnNameError,
    handleColumnNameChange,
    handleCancel,
    handleConfirm,
    setType,
    setTypeParams,
    draftColumn,
    stateDraftColumn,
    updateDraft,
  } = useNewDerivedColumnModel({
    viewKey,
    tableKey,
    availableColumnsFromServer,
    addDerivedColumn,
  });

  const handleAddDerivedColumn = useCallback(() => {
    handleColumnNameChange('new_column');
  }, [handleColumnNameChange]);

  if (!stateDraftColumn) {
    return (
      <DerivedColumnButtonWrapper>
        <NameWithIconWrapper>
          <TextButton onClick={handleAddDerivedColumn}>
            + Add Derived Column
            <DerivedDefinitionIcon />
          </TextButton>
        </NameWithIconWrapper>
        <SpacedConfigurationSeparator layout="horizontal" size="full" />
      </DerivedColumnButtonWrapper>
    );
  }
  return (
    <DerivedColumnEdit
      viewKey={viewKey}
      tableKey={tableKey}
      availableColumnsFromServer={availableColumnsFromServer}
      draftColumn={draftColumn}
      cancel={handleCancel}
      updateDraft={updateDraft}
      confirm={handleConfirm}
      collapsed={collapsed}
      setCollapsed={setCollapsed}
      updateName={handleColumnNameChange}
      setType={setType}
      setTypeParams={setTypeParams}
      isNewDraft={true}
      columnNameError={columnNameError}
    />
  );
};

export default DerivedColumnEditNew;
